import React, { memo, useEffect, useMemo } from 'react'
import { useHistory } from 'react-router'
import moment from 'moment'
import { Button } from 'transfix-ui/components/Button'
import { InlineMessage } from 'transfix-ui/components/InlineMessage'
import { useBookableShipmentAuctionSearchContext } from 'apps/fleet-planner/context/BookableShipmentAuctionSearchContext'
import { useTrackConversionContext } from 'apps/fleet-planner/context/track-conversion-source/TrackConversionContext'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import { BookableShipmentSavedSearch, IStop } from 'apps/fleet-planner/types'
import { getPickupTimeRange, getReloadsStopData } from 'apps/fleet-planner/utils/reloads'
import FORMATS from 'constants/datetime'

interface ILoadDetailsReloadMessage {
  stops: IStop[]
}

export const LoadDetailsReloadMessage = memo<ILoadDetailsReloadMessage>(({ stops = [] }) => {
  const { trackEvent } = useFMSAnalytics()
  const history = useHistory()
  const {
    getBookableAuctionShipments,
    isLoading,
    totalCount,
  } = useBookableShipmentAuctionSearchContext()
  const { setTrackConversion } = useTrackConversionContext()
  const { city, displayTimezone = '', startAt = '', stateCode } = getReloadsStopData(stops)
  const { pickupTimesEndAt, pickupTimesStartAt } = getPickupTimeRange(startAt, displayTimezone)
  const pickupTimes = useMemo(() => [`${pickupTimesStartAt}|${pickupTimesEndAt}`], [
    pickupTimesEndAt,
    pickupTimesStartAt,
  ])

  // TODO: Fix. This event misfires upon rendering of the component and can not be relied onto
  // useEffect(() => {
  //   trackEvent('LOAD_DETAILS_RELOAD_SEARCH_VIEW')
  // }, [trackEvent])

  /**
   * Everytime the stops are changed, we want to check if
   * the last stop is updated and adjust our filters accordingly to update totalCount
   */
  useEffect(() => {
    if (stops.length && pickupTimes && stateCode) {
      const filters: BookableShipmentSavedSearch = {
        pickupCity: city,
        pickupStateCode: stateCode,
        pickupStartDate: startAt,
        pickupTimes,
      }
      getBookableAuctionShipments({
        sortField: 'pickups',
        sortOrder: 'asc',
        filters: {
          ...filters,
        },
        pageNumber: 0,
      })
    }
  }, [city, getBookableAuctionShipments, pickupTimes, startAt, stateCode, stops])

  const generateReloadMessage = () => {
    const openBookLoadsPage = () => {
      setTrackConversion('web', 'reloads_shipment_search')
      const dateStr = moment(startAt).format(FORMATS.yearFirst)
      trackEvent('Reload', 'LOAD_DETAILS_RELOAD_SEARCH_CLICK')
      history.push(
        `/book?pickupCity=${city}&pickupStateCode=${stateCode}&pickupStartDate=${dateStr}&pickupTimes=${pickupTimes}`
      )
    }

    return (
      <span>
        <span className='b'>We found {totalCount} reloads</span> near {city}, {stateCode} on your
        dropoff date.
        <Button variant='text' noPadding onClick={openBookLoadsPage}>
          View Reloads
        </Button>
      </span>
    )
  }

  return totalCount > 0 && !isLoading ? <InlineMessage message={generateReloadMessage()} /> : <></>
})
